import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { HelpersService, ServiceRequestService } from 'src/app/services';
import { WorkshopJobcardCancelOptionsComponent } from '../workshop-jobcard-live-updates/workshop-jobcard-cancel-options/workshop-jobcard-cancel-options.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Statuses } from 'src/app/enums/statuses.enum'
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { BroadcastService } from 'src/app/services/broadcast.service';

@Component({
  selector: 'app-workshop-jobcard-live-statuses',
  templateUrl: './workshop-jobcard-live-statuses.component.html',
  styleUrls: ['./workshop-jobcard-live-statuses.component.scss'],
  providers: [MessageService]
})
export class WorkshopJobcardLiveStatusesComponent implements OnChanges {

  @Input() jobcard: any;
  @Input() serviceTypes: any[] = [];
  @Input() showNotesInline: boolean = false;
  @Input() goToMessaging: boolean = false;
  @Input() cancelDisabled: boolean = false;
  @Output() jobcardChange = new EventEmitter<any>();

  showStatusActions: boolean = false;
  jobActions: any[];
  statusList: any[] = this.appConfig.getStatusList();
  sendComms: boolean = true;
  hasMandatoryChecklistItems: boolean = false;
  originalStatusID: any;
  reopening: boolean = false;
  markingCollected: boolean = false;
  isLocked: boolean = false;
  lockJobCardOnCollection: boolean = false;
  public canDeviceHover: boolean = true;
  public subscription: Subscription;

  constructor(
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private workshopJobcardCreateService: WorkshopJobcardCreateService,
    private messageService: MessageService,
    private serviceRequest: ServiceRequestService,
    private confirmationService: ConfirmationService,
    public broadcastService: BroadcastService
  ) {
  }

  ngOnInit() {
    this.originalStatusID = this.jobcard.statusID;
    this.setCanDeviceHover();
    this.createSubscription();
  }

  ngOnChanges() {
    this.createJobActions();
    this.lockJobCardOnCollection = !!this.helpersService.getPartnerData()?.LockJobCardOnCollection;
    this.isLocked = this.helpersService.isJobcardLocked(this.jobcard);
  }

  createSubscription() {
    this.subscription = this.broadcastService.getMessage().subscribe((data) => {
      let message = data.message;
      if (message?.message === 'update-checklist-mandatory-status') {
        this.hasMandatoryChecklistItems = message?.hasMandatoryChecklistItems;
      }
    });
  }

  createJobActions() {
    if (this.jobcard.isFitting) {
      this.jobActions = [
        {
          key: Statuses.FITTINGCOMPLETED,
          label: this.translate.instant('bikeshop.job_actions.job_completed'),
          id: 41,
        },
        {
          key: Statuses.CANCELED,
          label: this.translate.instant('bikeshop.job_actions.cancel_job'),
          id: 100,
        },
      ];
    } else {
      this.jobActions = this.appConfig.getJobActions();
      if (!this.helpersService.getPartnerData().ShowINeedHelp) {
        this.jobActions = this.jobActions.filter((x) => {
          return x.key != Statuses.INEEDHELP;
        });
      }
    }
  }

  getCurrentStatusLabel() {
    var status = this.statusList.find(x => x.key === this.jobcard.statusID);
    return status ? status.label : 'Unknown Status';
  }

  getStatusStyle() {
    var status = this.statusList.find(x => x.key === this.jobcard.statusID);
    return status && status.styleClass ? status.styleClass : null;
  }

  getStatusIndicatorStyle(statusID) {
    var status = this.statusList.find(x => x.key === statusID);
    return status && status.styleClass ? status.styleClass : null;
  }


  toggleStatusDropdown(event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent event bubbling to document
    }
    this.showStatusActions = !this.showStatusActions;
  }

  async selectStatusOption(option) {
    if (option.key === 40 && this.hasMandatoryChecklistItems) return;
    if (option.key === Statuses.CANCELED && this.cancelDisabled) return;

    this.originalStatusID = this.jobcard.statusID;
    //this.jobcard.statusID = option.key;
    this.showStatusActions = false;
    if (option.key === Statuses.CANCELED) {
      this.cancelJobCard();
    } else {
      var result = await this.workshopJobcardCreateService.updateJobCardStatus(this.jobcard, option.key, this.sendComms, this.messageService, this.translate).toPromise();
      this.jobcardChange.emit({ ...this.jobcard });
    }

  }

  cancelJobCard() {
    const modalRef = this.modalService.open(WorkshopJobcardCancelOptionsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'md'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.messageService = this.messageService;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('bikeshop.modal.update_job_card.job_card.message_job_cancelled', { JobCardNo: this.jobcard.jobCardNo }),
        });
        setTimeout(() => {
          this.activeModal.dismiss('Cross click');
        }, 5000);
      },
      (onrejected) => {
        this.jobcard.statusID = this.originalStatusID;
      },
    );
  }

  reopenJobCard() {
    this.confirmationService.confirm({
      key: 'jobcard',
      header: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.reopen_job_card',
      ),
      message: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.reopen_job_card_detail',
      ),
      acceptLabel: this.translate.instant('general.yes'),
      accept: () => {
        this.reopening = true;
        this.serviceRequest.reopenJobcard(this.jobcard.id).subscribe(
          (res) => {
            this.jobcard.statusID = res.StatusID;
            this.reopening = false;
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.job_card.message_job_card_reopened',
                { JobCardNo: this.jobcard.jobCardNo },
              ),
            });
          },
          (err) => {
            this.reopening = false;
          },
        );
      },
      rejectLabel: this.translate.instant('general.no'),
    });
  }

  markAsCollected() {
    if (this.lockJobCardOnCollection) {
      this.confirmationService.confirm({
        key: 'jobcard',
        header: this.translate.instant('bikeshop.workshop.jobcard.manage.mark_as_collected'),
        message: `<div style="max-width: 400px; word-wrap: break-word;">
                   
                    ${this.translate.instant('bikeshop.workshop.jobcard.manage.mark_as_collected_confirm_message')}
                  </div>`,
        acceptLabel: this.translate.instant('general.yes'),
        rejectLabel: this.translate.instant('general.no'),

        accept: () => {
          this.collectJobCard();
        },
      });
    } else {
      this.collectJobCard();
    }
  }

  collectJobCard() {
    this.markingCollected = true;
    this.serviceRequest
      .collect(this.jobcard.id, this.sendComms)
      .subscribe((jobcard) => {
        this.jobcard.statusID = jobcard.StatusID;
        this.markingCollected = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('bikeshop.services.message_collected', { jobcard: this.jobcard.jobCardNo }),
        });
        this.jobcardChange.emit({ ...this.jobcard });
      }, err => {
        this.markingCollected = false;
      });
  }

  setCanDeviceHover() {
    if (window.matchMedia("(hover: hover)").matches) {
      this.canDeviceHover = true;
    } else if (window.matchMedia("(hover: none)").matches) {
      this.canDeviceHover = false;
    }
  }

  toggleItemIsHere() {
    if (this.jobcard.statusID >= 25 && this.jobcard.statusID != 35) {
      return; // Disabled state
    }

    // Create a synthetic event object to match the existing updateItemIsHere method
    const syntheticEvent = {
      checked: !this.jobcard.itemIsHere
    };

    this.updateItemIsHere(syntheticEvent);
  }

  updateItemIsHere(event) {
    this.jobcard.itemIsHere = event.checked;
    this.serviceRequest.updateWorkshopJobCard(this.jobcard).subscribe((result) => {
      if (!event.checked) {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_undo_bike_received',
            { JobCardNo: this.jobcard.jobCardNo },
          ),
        });
        if (this.jobcard.statusID === 20) {
          this.serviceRequest
            .undoBikeReceived(this.jobcard.id)
            .subscribe((res) => {
              this.jobcard.statusID = res.StatusID;
            });
        }
      } else {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.message_bike_received_and_assigned',
            { JobCardNo: this.jobcard.jobCardNo },
          ),
        });
        if (this.jobcard.statusID < 20) {
          this.serviceRequest
            .bikeReceived(this.jobcard.id, this.sendComms)
            .subscribe((res) => {
              this.jobcard.statusID = res.StatusID;
            });
        }
      }
    });
  }
}
